import Drupal from 'Drupal';

(function ($) {
  Drupal.behaviors.signup = {
    attach: (context) => {
      if ($('.homepage__subdomains__nav').length > 0) {
        $('.homepage__subdomains__nav').addClass('newsletter_present');
      }

      // session storage timmer
      if (sessionStorage.getItem('dimissTimer')) {
        $('.sign-up-email').addClass('delayedSignUp');
        setTimeout(function () {
          $('.delayedSignUp .sign-up-email__headings-info').show();
          $('.delayedSignUp .sign-up-email__headings-info').css({ opacity: 1 });
          $('.delayedSignUp.sign-up-email').css({
            padding: '10px 30px',
            transition: '0.3s',
          });
        }, sessionStorage.getItem('dimissTimer'));
      }

      $('.close-headings').on('click', function () {
        // adding Timmer with session storage
        sessionStorage.setItem('dimissTimer', 30000);

        $('.sign-up-email__headings-info').css({ opacity: 0 });
        $('.sign-up-email__headings-info').slideUp();
        $(this).closest('.sign-up-email').css({
          padding: 0,
          transition: '0.3s',
        });
        $(this)
          .closest('.sign-up-email')
          .find('.sign-up-email__content')
          .slideUp();
      });

      $('.sign-up-email .sign-up-email__button').on('click', function () {
        $('.sign-up-email__headings-info').show();
        $('.sign-up-email__headings-info').css({ opacity: 1 });
        $(this).closest('.sign-up-email').css({
          padding: '10px 30px',
          transition: '0.3s',
        });
        $(this)
          .closest('.sign-up-email')
          .find('.sign-up-email__content')
          .slideToggle();
        $(this).closest('.sign-up-email').toggleClass('signup-form--active');
      });
    },
  };
})(jQuery);
